import { getSession } from "../../../auth";
import api from "../../../api";

const formatNumber = (incomingData, reverse) => {
  if (reverse === undefined) {
    reverse = false;
  }

  if (incomingData.info) {
    if (reverse) {
      if (incomingData.info.extension_description) {
        return incomingData.info.extension_description + " (" + incomingData.number + ")";
      }
      else if (incomingData.info.agent_username) {
        var num = incomingData.info.agent_username;
        if (num.indexOf("_") !== -1) {
          num = num.split("_")[1];
        }
        return incomingData.info.agent_name + " (" + num + ")";
      }

    } else {
      if (incomingData.info.agent_username) {
        var num = incomingData.info.agent_username;
        if (num.indexOf("_") !== -1) {
          num = num.split("_")[1];
        }
        return incomingData.info.agent_name + " (" + num + ")";
      } else if (incomingData.info.extension_description) {
        return incomingData.info.extension_description + " (" + incomingData.number + ")";
      }
    }
  }
  return incomingData.number;
};

// Check URL for telephony tab
const checkTelephonyTab = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const selectedTab = urlParams.get('selectedTab');
  const isOnChatPage = window.location.pathname.includes('/chat');
  
  return isOnChatPage && selectedTab === 'telephony';
};

const isInstantVoiceIntegrated = (session = getSession()) => {
  const profile = session?.profile;

  return Boolean(
    profile?.instantvoice_url &&
    profile?.instantvoice_accountcode &&
    profile?.instantvoice_api_key &&
    profile?.instantvoice_agent_code
  );
};

const shouldUseNewWebphone = (session = getSession()) => {
  const profile = session?.profile;
  const enterprise = profile?.enterprise;
  const agent = profile?.agent;

  const hasTelephony = Boolean(
    enterprise?.has_voice || enterprise?.whatsapp_calling
  );
  const hasExtension = Boolean(
    agent?.external_username || agent?.preferred_interface
  );

  if (!enterprise?.has_webphone || !hasTelephony || !hasExtension) {
    return false;
  }

  const externalServerUri = agent?.external_server_uri;

  return !(
    externalServerUri &&
    externalServerUri !== "" &&
    !isInstantVoiceIntegrated(session)
  );
};

const getCrmData = async (phoneNumber, setData) => {
  try {
    const enterpriseId = getSession().profile.enterprise.id;
    const response = await api.get(
      `api/enterprises/${enterpriseId}/contacts/?search=${encodeURIComponent(
        phoneNumber
      )}`
    );
    if (response.status >= 200 && response.status < 300) {
      const results = response.data.results || response.data || [];
      if (results.length > 0) {
        setData(results[0]);
      } else {
        setData(null);
      }
    }
  } catch (error) {
    console.error("Error fetching CRM data:", error);
    setData(null);
  }
}

const isStr = (value) => {
  return typeof value === 'string' || value instanceof String;
}


export {
  formatNumber,
  checkTelephonyTab,
  getCrmData,
  isStr,
  isInstantVoiceIntegrated,
  shouldUseNewWebphone
};